import React from 'react';
import { useRegistration } from './RegistrationContext';
const getDutchDates = () => {
  const months = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const formatDate = (d: Date) => `${d.getDate()} ${months[d.getMonth()]}`;
  return `${formatDate(today)} of ${formatDate(tomorrow)}`;
};
export const StickyBar = () => {
  const {
    openPopup
  } = useRegistration();
  return <div className="fixed bottom-0 left-0 right-0 z-40 bg-white shadow-[0_-2px_10px_rgba(0,0,0,0.1)]" data-id="element-329">
      <div className="max-w-3xl mx-auto px-4 py-2 text-center" data-id="element-330">
        <p className="text-sm text-gray-700 mb-2" data-id="element-331">
          {getDutchDates()} • 10:00, 13:00 of 20:00
        </p>
        <button onClick={openPopup} className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg transition-colors text-base" data-id="element-332">
          GRATIS WEBINAR: Communiceren Met Je Hond
        </button>
      </div>
    </div>;
};